import * as React from 'react';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, useCmsData, useAddToProductViewHistory, ProductDetailTitleView, StickyAside, SizeGuideModalView, NonRxProductCTA, TryOnButton, ProductDetailUsps, ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import { PowerSelector } from './components/PowerSelector/PowerSelector.js';
import { ReadyReadersFeatures } from './components/ReadyReaderFeatures/ReadyReadersFeatures.js';
import { ProductImageGalleryContainer } from '../../ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import { PDPPriceSectionContainer } from '../Components/PDPPriceSection/PDPPriceSectionContainer.js';
import { ProductDetailSpecificationContainer } from '../../ProductDetailSpecification/ProductDetailSpecificationContainer.js';

const ReadyReaders = ({ activeSku , activeVariant , addToCartRef , brandLink , handleConversionEvent , handleVariantPick , isMobile , isOrderable , isProductLabelEnabled , labels , onCTAClick , productImageAlt , stockCount , variant , variants , storesRoute  })=>{
    const { isFrameSizeVTOEnabled , featureConfigs  } = useFeatureToggles();
    const { channelAvailability  } = variant;
    const { Slots  } = useProductDetailSlots();
    const { sizeGuideDocument , usps: productTypeUsps  } = useCmsData();
    useAddToProductViewHistory({
        variant,
        variants
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-ready-readers"
    }, isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink,
        sku: variant.sku
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), /*#__PURE__*/ React.createElement("aside", {
        className: "product-detail__aside"
    }, /*#__PURE__*/ React.createElement(StickyAside, {
        bottomBoundary: ".product-detail",
        isEnabled: !isMobile
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink,
        sku: variant.sku
    })), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), /*#__PURE__*/ React.createElement(PDPPriceSectionContainer, {
        className: "product-detail__specification-prices"
    }), !isMobile && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-ready-readers__power_selector"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-ready-readers__label"
    }, labels.power, /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: stockCount,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    })), /*#__PURE__*/ React.createElement(PowerSelector, {
        handleVariantPick: handleVariantPick,
        variants: variants,
        activeSku: activeSku
    })), sizeGuideDocument && /*#__PURE__*/ React.createElement(SizeGuideModalView, {
        sku: activeSku,
        productName: productImageAlt,
        isVtoEnabled: !!activeVariant.vtoEnabled && isFrameSizeVTOEnabled,
        sizeGuideContent: sizeGuideDocument
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ],
        isExcludedFromCheckout: variant.excludedFromCheckout
    }) : null, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            onSuccess: onCTAClick
        }
    })), activeVariant.vtoEnabled && featureConfigs.virtualTryOn === 'DITTO' && /*#__PURE__*/ React.createElement(TryOnButton, null), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, null)))))), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-ready-readers__description",
        "aria-label": "product-information-block",
        "data-t": "ready-readers-description"
    }, /*#__PURE__*/ React.createElement(ReadyReadersFeatures, {
        variant: variant,
        labels: labels
    }), /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: variant.header,
        description: variant.description,
        usps: variant.usps
    }), /*#__PURE__*/ React.createElement(ProductDetailSpecificationContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }));
};

export { ReadyReaders };
//# sourceMappingURL=ReadyReaders.js.map
